// extracted by mini-css-extract-plugin
export default {"accentButton":"AccentButton_accentButton__ZSLk6"};